import './CronExpressionField.css';

import React from 'react';
import FieldComponent from '../../b2b-common/FieldComponent';
import { getIconWithTooltip } from './helper';
import { Update, UpdateDisabled } from '@mui/icons-material';
import { parseCronExpression } from './CronExpressionUpdater';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';

export const CronData = ({ cronExpression }) => {
    const { t } = useB2BTranslation('b2b-plans');
    if (!cronExpression) {
        return (
            <div className='cron-data'>
                {getIconWithTooltip(UpdateDisabled, {}, t('Sampling frequency not set'))}
            </div >
        );
    } else {
        const { frequency, interval } = parseCronExpression(cronExpression);
        return (
            <div className='cron-data'>
                {getIconWithTooltip(Update, {}, t('Expected sampling frequency'))}
                <div className='cron-data-interval'>{interval}</div>
                <div className='cron-data-frequency'>{t(frequency)}</div>
            </div>
        );
    }
};


const CronExpressionField = ({ cronExpression, justShowIfValue = true }) => {
    const { t } = useB2BTranslation('b2b-plans');
    if (justShowIfValue && !cronExpression) {
        return null;
    }
    return (
        <FieldComponent
            label={t('Expected Frequency')}
            component={
                <CronData cronExpression={cronExpression} />
            }
            className='cron-expression-field' />
    );
};

export default CronExpressionField;